import apiClient from './api';

/**
 * What's New API Service
 * Returns FULL release data (all WhatsNew items)
 * Not filtered by customer - shows complete release information
 */
export const whatsNewApi = {
  /**
   * Get What's New for a release
   * Returns ALL items in the release (no customer filtering)
   * @param {string} releaseVersion - Optional release version (defaults to latest)
   * @returns {Promise} What's New report
   */
  analyzeWhatsNew: (releaseVersion = null) => {
    const body = releaseVersion ? { releaseVersion } : {};
    return apiClient.post('/api/whats-new/analyze', body);
  },

  /**
   * Get available SAP release versions (from SAP API)
   * @returns {Promise} Array of release versions
   */
  getAvailableReleases: () => {
    return apiClient.get('/api/whats-new/releases');
  },

  /**
   * Get stored release versions from database
   * @returns {Promise} Array of release versions
   */
  getStoredReleases: () => {
    return apiClient.get('/api/whats-new/stored-releases');
  },

  /**
   * Fetch release data from SAP API and save to database
   * @param {string} releaseVersion - Release version to fetch and save
   * @returns {Promise} Success response
   */
  saveRelease: (releaseVersion) => {
    return apiClient.post('/api/whats-new/save-release', { releaseVersion });
  },
};

// Default export
export default whatsNewApi;
